module.exports = __webpack_public_path__ + "img/techrim.684b183b.png";